import { IconPropsType } from '..';

export const CentralPayIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="80"
    height="14"
    viewBox="0 0 80 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_26855_75005)">
      <path
        d="M7.95898 8.86836L10.4762 11.3926L11.5528 10.316C11.984 9.88476 11.984 9.18476 11.5528 8.75356L9.81678 7.01757L11.5528 5.28157C11.984 4.85037 11.984 4.15037 11.5528 3.71918L10.4762 2.64258L7.96458 5.15977"
        fill="#5073FB"
      />
      <path
        d="M6.19085 10.5818C4.09226 10.5818 2.41226 8.75904 2.64886 6.61424C2.82386 5.03785 4.05866 3.74145 5.62526 3.49785C6.36025 3.38305 7.06165 3.49785 7.67205 3.77785L9.59705 1.85286C8.57505 1.17526 7.34025 0.79166 6.01585 0.82806C2.84486 0.91626 0.208669 3.45865 0.0126695 6.62404C-0.20993 10.215 2.64746 13.2082 6.19225 13.2082C7.44385 13.2082 8.61005 12.833 9.58444 12.1918L7.65665 10.264C7.21005 10.467 6.71305 10.5804 6.19085 10.5804V10.5818Z"
        fill="#5073FB"
      />
      <path
        d="M6.88336 6.237L7.95944 5.16093L9.81658 7.01807L7.95944 8.87521L6.88336 7.79913C6.45175 7.36752 6.45274 6.66763 6.88336 6.237Z"
        fill="#1934F7"
      />
      <path
        d="M15.1648 7.02553C15.1648 4.83734 16.9246 3.40234 18.921 3.40234C20.1194 3.40234 21.0952 3.93434 21.7308 4.73374L20.5184 5.69554C20.1642 5.26714 19.572 5.00114 18.9504 5.00114C17.752 5.00114 16.8952 5.85934 16.8952 7.02693C16.8952 8.19453 17.7534 9.06813 18.9504 9.06813C19.572 9.06813 20.1628 8.80213 20.5184 8.37373L21.7308 9.33553C21.0952 10.1335 20.1194 10.6669 18.921 10.6669C16.9246 10.6669 15.1648 9.21793 15.1648 7.02973V7.02553Z"
        fill="white"
      />
      <path
        d="M28.8749 7.63173H23.5213C23.7131 8.59353 24.4537 9.11013 25.4883 9.11013C26.2275 9.11013 26.9527 8.78533 27.3517 8.22253L28.5053 9.09473C27.8697 10.0999 26.6419 10.6627 25.3847 10.6627C23.3295 10.6627 21.7615 9.18433 21.7615 7.02553C21.7615 4.86674 23.4037 3.40234 25.3847 3.40234C27.3657 3.40234 28.9043 4.80794 28.9043 6.96673C28.9043 7.15853 28.8889 7.38113 28.8749 7.63173ZM27.2033 6.43334C27.0997 5.48694 26.3605 4.92554 25.3987 4.92554C24.4369 4.92554 23.7271 5.38334 23.5199 6.43334H27.2019H27.2033Z"
        fill="white"
      />
      <path
        d="M36.2248 6.61169V10.4869H34.5098V6.73069C34.5098 5.62189 33.8448 5.02969 33.0748 5.02969C32.3048 5.02969 31.315 5.48749 31.315 6.81889V10.4869H29.5986V3.5807H31.315V4.67549C31.6692 3.8033 32.75 3.4043 33.4598 3.4043C35.2336 3.4043 36.2248 4.60269 36.2248 6.61309V6.61169Z"
        fill="white"
      />
      <path
        d="M41.0018 3.58041V4.94121H39.5374V10.4866H37.8224V4.93981H36.5806V3.57901H37.8224V1.03662H38.4328C39.0432 1.03662 39.5374 1.53082 39.5374 2.14122V3.58041H41.0018Z"
        fill="white"
      />
      <path
        d="M46.2516 3.63894L45.9114 5.26574C45.5124 5.05854 45.1568 5.01374 44.9062 5.01374C43.782 5.01374 43.1618 6.13794 43.1618 8.07553V10.4863H41.4314V3.58014H43.1478V5.05854C43.5174 3.90494 44.272 3.40234 45.1288 3.40234C45.5432 3.40234 45.987 3.49054 46.253 3.63894H46.2516Z"
        fill="white"
      />
      <path
        d="M51.5602 3.5807H53.2752V10.4869H51.5602V9.40748C51.1024 10.1621 50.1854 10.6647 49.1942 10.6647C47.3463 10.6647 45.8665 9.17088 45.8665 7.02749C45.8665 4.88409 47.2861 3.4043 49.2376 3.4043C50.184 3.4043 51.101 3.8187 51.5588 4.54249V3.5807H51.5602ZM51.5308 7.02609C51.5308 5.84309 50.555 5.00029 49.5344 5.00029C48.4257 5.00029 47.5829 5.91729 47.5829 7.02609C47.5829 8.13489 48.4256 9.06728 49.5498 9.06728C50.6152 9.06728 51.5308 8.17969 51.5308 7.02609Z"
        fill="white"
      />
      <path
        d="M54.4304 10.4865V0.791504H55.0408C55.6512 0.791504 56.1454 1.2857 56.1454 1.8961V10.4865H54.429H54.4304Z"
        fill="white"
      />
      <path
        d="M64.7078 7.04093C64.7078 9.24453 63.1398 10.6641 61.3212 10.6641C60.449 10.6641 59.4872 10.3099 59.014 9.56933V13.1281H57.2976V3.58014H59.014V4.49714C59.4872 3.75794 60.4784 3.40234 61.3058 3.40234C63.1244 3.40234 64.7078 4.82194 64.7078 7.04093ZM62.9928 7.04093C62.9928 5.90274 62.1052 4.99974 61.0412 4.99974C59.9772 4.99974 59.0448 5.82854 59.0448 7.04093C59.0448 8.25333 60.05 9.06673 61.0412 9.06673C62.1066 9.06673 62.9928 8.19453 62.9928 7.04093Z"
        fill="white"
      />
      <path
        d="M70.7277 3.5807H72.4427V10.4869H70.7277V9.40748C70.2699 10.1621 69.3529 10.6647 68.3617 10.6647C66.5137 10.6647 65.0339 9.17088 65.0339 7.02749C65.0339 4.88409 66.4535 3.4043 68.4051 3.4043C69.3515 3.4043 70.2685 3.8187 70.7263 4.54249V3.5807H70.7277ZM70.6969 7.02609C70.6969 5.84309 69.7211 5.00029 68.7005 5.00029C67.5917 5.00029 66.7489 5.91729 66.7489 7.02609C66.7489 8.13489 67.5917 9.06728 68.7159 9.06728C69.7813 9.06728 70.6969 8.17969 70.6969 7.02609Z"
        fill="white"
      />
      <path
        d="M79.9999 3.58008H78.1519L76.3767 7.95647L74.5875 3.58008H72.7087L75.4597 9.99766L74.2011 13.1281H76.0155L79.9999 3.58008Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_26855_75005">
        <rect
          width="80"
          height="12.4166"
          fill="white"
          transform="translate(0 0.791504)"
        />
      </clipPath>
    </defs>
  </svg>
);
